const MS_PER_DAY = 24 * 60 * 60 * 1000

const formatUsDate = (date) => date.toLocaleString("en-US").split(",")[0]

export const DATE_PRESETS = {
  LAST_90_DAYS: "LAST_90_DAYS",
  LAST_12_MONTHS: "LAST_12_MONTHS",
  LAST_2_7_YEARS: "LAST_2_7_YEARS",
  LAST_2_5_YEARS: "LAST_2_5_YEARS",
  LAST_7_YEARS_OR_MORE: "LAST_7_YEARS_OR_MORE",
}

export const getDateRangeFromPreset = (preset) => {
  const now = new Date()
  let startDate
  let endDate = now

  switch (preset) {
    case DATE_PRESETS.LAST_90_DAYS:
      startDate = new Date(now.getTime() - MS_PER_DAY * 90)
      break
    case DATE_PRESETS.LAST_12_MONTHS:
      startDate = new Date(now.getTime() - MS_PER_DAY * 365)
      break
    case DATE_PRESETS.LAST_2_7_YEARS:
      startDate = new Date(now.getTime() - MS_PER_DAY * 2557)
      endDate = new Date(now.getTime() - MS_PER_DAY * 730)
      break
    case DATE_PRESETS.LAST_2_5_YEARS:
      startDate = new Date(now.getTime() - MS_PER_DAY * 1826)
      endDate = new Date(now.getTime() - MS_PER_DAY * 730)
      break
    case DATE_PRESETS.LAST_7_YEARS_OR_MORE:
      startDate = new Date("01/01/1990")
      endDate = new Date(now.getTime() - MS_PER_DAY * 2557)
      break
    default:
      startDate = new Date(now.getTime() - MS_PER_DAY * 730)
      break
  }

  return [formatUsDate(startDate), formatUsDate(endDate)]
}
